import { models } from '@kurtosys/ksys-app-template';

export const AUTHENTICATION: models.appsInitialize.IAppAuthentication = {
	token: '68ed6bb4-a8e6-41e1-a816-4bc2f56b1448',
	serviceUrl: 'https://api-rel.fundpress.io',
};
